/* eslint-disable @stylistic/quote-props */
/* cspell:disable */ // noinspection SpellCheckingInspection
const timezoneSmall = /* trim-file-start */{ // tz database version: 2026b, years 2021-2031
  version: '2026b',
  years: '2021-2031',
  deltaTs: '69.36 69.36 69.29 69.20 69.18 69.14 69.11',
  leapSeconds: '912 1096 1461 1826 2191 2557 2922 3287 3652 4199 4564 4929 5660 6574 7305 7670 8217 8582 8947 9496 10043 10592 13149 14245 15522 16617 17167',
  'Africa/Abidjan': '+0000 +0000 0;0/0/GMT;;;;48e5;BFCIGMGNMLMRSHSLSNTG',
  'Africa/Algiers': '+0100 +0100 0;10/0/CET;;;;26e5;DZ',
  'Africa/Cairo': '+0200 +0200 60;20/0/EET 30/10/EEST;101010101010101010;29NW0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0;2023 10 0 5 24:0 0 0,2023 4 0 6 0:0 0 60;15e6;EG',
  'Africa/Casablanca': '+0100 +0100 0;10/0/%z 0/-10/%z;1010101010101010101010;24Pe0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00;;32e5;MA',
  'Africa/Johannesburg': '+0200 +0200 0;20/0/SAST;;;;84e5;LSSZZA',
  'Africa/Juba': '+0300 +0200 0;30/0/EAT 20/0/CAT;1;24nx0;;;SS',
  'Africa/Khartoum': '+0200 +0200 0;20/0/CAT;;;;51e5;SD',
  'Africa/Lagos': '+0100 +0100 0;10/0/WAT;;;;17e6;AOBJCDCFCGCMGAGQNENG',
  'Africa/Nairobi': '+0300 +0300 0;30/0/EAT;;;;47e5;DJERETKEKMMGSOTZUGYT',
  'Africa/Tripoli': '+0200 +0200 0;20/0/EET;;;;11e5;LY',
  'America/Adak': '-1000 -1000 60;-a0/0/HST -90/10/HDT;1010101010101010101010;24Ec0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;326;US',
  'America/Anchorage': '-0900 -0900 60;-90/0/AKST -80/10/AKDT;1010101010101010101010;24Eb0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;30e4;US',
  'America/Asuncion': '-0400 -0300 0;-40/0/%z -30/10/%z -30/0/%z;10101012;261g0 19X0 1fB0 19X0 1fB0 19X0 1ip0 3z0;;28e5;PY',
  'America/Boise': '-0700 -0700 60;-70/0/MST -60/10/MDT;1010101010101010101010;9VJ0 1Uhz0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;21e4;US',
  'America/Caracas': '-0400 -0400 0;-40/0/%z;;;;29e5;VE',
  'America/Chicago': '-0600 -0600 60;-60/0/CST -50/10/CDT;1010101010101010101010;24E80 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;92e5;US',
  'America/Chihuahua': '-0700 -0600 0;-70/0/MST -60/10/MDT -60/0/CST;1012;24Mx0 1nX0 11B0 1nX0;;81e4;MX',
  'America/Ciudad_Juarez': '-0700 -0700 60;-70/0/MST -60/10/MDT -60/0/CST;10120101010101010101010;24E90 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;23e3;MX',
  'America/Coyhaique': '-0400 -0300 0;-40/0/%z -30/10/%z -30/0/%z;10101012;25O40 1nX0 14p0 1lb0 11B0 1qL0 11B0 1hb0',
  'America/Denver': '-0700 -0700 60;-70/0/MST -60/10/MDT;1010101010101010101010;24E90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;26e5;US',
  'America/Detroit': '-0500 -0500 60;-50/0/EST -40/10/EDT;1010101010101010101010;cUT0 1Rin0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;37e5;US',
  'America/Goose_Bay': '-0400 -0400 60;-40/0/AST -30/10/ADT;1010101010101010101010;1FPE0 onB0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;76e2;CA',
  'America/Halifax': '-0400 -0400 60;-40/0/AST -30/10/ADT;1010101010101010101010;24E60 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;39e4;CA',
  'America/Havana': '-0500 -0500 60;-50/0/CST -40/10/CDT;1010101010101010101010;24E50 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0;2012 11 1 1 0:0 1 0,2013 3 8 1 0:0 1 60;21e5;CU',
  'America/Lima': '-0500 -0500 0;-50/0/%z;;;;11e6;PE',
  'America/Los_Angeles': '-0800 -0800 60;-80/0/PST -70/10/PDT;1010101010101010101010;24Ea0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;15e6;US',
  'America/Managua': '-0600 -0600 0;-60/0/CST;;;;22e5;NI',
  'America/Mazatlan': '-0700 -0700 0;-70/0/MST -60/10/MDT;1010;24Mx0 1nX0 11B0 1nX0;;44e4;MX',
  'America/Mexico_City': '-0600 -0600 0;-60/0/CST -50/10/CDT;1010;24Mw0 1nX0 11B0 1nX0;;20e6;MX',
  'America/Miquelon': '-0300 -0300 60;-30/0/%z -20/10/%z;1010101010101010101010;24E50 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;61e2;PM',
  'America/New_York': '-0500 -0500 60;-50/0/EST -40/10/EDT;1010101010101010101010;24E70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;21e6;US',
  'America/Noronha': '-0200 -0200 0;-20/0/%z;;;;30e2;BR',
  'America/Nuuk': '-0300 -0200 60;-30/0/%z -20/10/%z -20/0/%z -10/10/%z;101023232323232323232;oXh0 1Fd80 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;17e3;GL',
  'America/Ojinaga': '-0700 -0600 60;-70/0/MST -60/10/MDT -60/0/CST -50/10/CDT;1012323232323232323232;24E90 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;23e3;MX',
  'America/Panama': '-0500 -0500 0;-50/0/EST;;;;15e5;KYPA',
  'America/Phoenix': '-0700 -0700 0;-70/0/MST;;;;42e5;US',
  'America/Port-au-Prince': '-0500 -0500 60;-50/0/EST -40/10/EDT;1010101010101010101010;24E70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2017 11 1 1 2:0 0 0,2017 3 8 1 2:0 0 60;23e5;HT',
  'America/Santiago': '-0400 -0400 60;-40/0/%z -30/10/%z;10101010101010101010;25O40 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0;2019 4 2 1 3:0 2 0,2023 9 2 1 4:0 2 60;62e5;CL',
  'America/Santo_Domingo': '-0400 -0400 0;-40/0/AST;;;;29e5;DO',
  'America/Sao_Paulo': '-0300 -0300 0;-30/0/%z;;;;20e6;BR',
  'America/Scoresbysund': '-0200 -0200 60;-20/0/%z 0/10/%z -10/0/%z -10/10/%z;1212123030303030303030;rm20 1COn0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;452;GL',
  'America/St_Johns': '-0330 -0330 60;-3u/0/NST -2u/10/NDT;1010101010101010101010;1FPDu onB0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;2007 11 1 1 2:0 0 0,2007 3 8 1 2:0 0 60;11e4;CA',
  'America/Vancouver': '-0800 -0700 0;-80/0/PST -70/10/PDT -70/0/MST;101010101012;24Ea0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0;;23e5;CA',
  'Antarctica/Casey': '+1100 +0800 0;b0/0/%z 80/0/%z;10101;24DN0 1lf1 14kX 1lf1 13bX;;10;AQ',
  'Antarctica/Macquarie': '+1000 +1000 60;a0/0/AEST b0/10/AEDT;1010101010101010101010;1BnO0 roq0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0;2008 4 1 1 2:0 1 0,2001 10 1 1 2:0 1 60;1;AU',
  'Antarctica/Troll': '+0000 +0000 120;0/0 20/20;1010101010101010101010;24JB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;2004 10 0 1 1:0 2 0,2005 3 0 1 1:0 2 120;40;AQ',
  'Antarctica/Vostok': '+0700 +0500 0;70/0/%z 50/0/%z;1;2bnv0;;25;AQ',
  'Asia/Almaty': '+0600 +0500 0;60/0/%z 50/0/%z;1;2bR60;;15e5;KZ',
  'Asia/Amman': '+0200 +0300 0;20/0/EET 30/10/EEST 30/0/%z;1012;24IK0 1qM0 LA0 1C00;;25e5;JO',
  'Asia/Bangkok': '+0700 +0700 0;70/0/%z;;;;15e6;KHLATHVN',
  'Asia/Beirut': '+0200 +0200 60;20/0/EET 30/10/EEST;1010101010101010101010;24Jy0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0;1999 10 0 1 0:0 0 0,1993 3 0 1 0:0 0 60;22e5;LB',
  'Asia/Chita': '+0900 +0900 0;90/0/%z;;;;33e4;RU',
  'Asia/Colombo': '+0530 +0530 0;5u/0/%z;;;;22e5;LK',
  'Asia/Damascus': '+0200 +0300 0;20/0/EET 30/10/EEST 30/0/%z;1012;24IK0 1qL0 WN0 1qL0;;26e5;SY',
  'Asia/Dhaka': '+0600 +0600 0;60/0/%z;;;;16e6;BD',
  'Asia/Dubai': '+0400 +0400 0;40/0/%z;;;;39e5;AEOM',
  'Asia/Famagusta': '+0300 +0200 60;30/0/%z 30/10/EEST 20/0/EET;1212121212121212121212;1Urd0 9Jc0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;;CY',
  'Asia/Gaza': '+0200 +0200 0;20/0/EET 30/10/EEST;1010101010101010101010;24Ja0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0;;18e5;PS',
  'Asia/Hong_Kong': '+0800 +0800 0;80/0/HKT;;;;73e5;HK',
  'Asia/Jakarta': '+0700 +0700 0;70/0/WIB;;;;31e6;ID',
  'Asia/Jayapura': '+0900 +0900 0;90/0/WIT;;;;26e4;ID',
  'Asia/Jerusalem': '+0200 +0200 60;20/0/IST 30/10/IDT;1010101010101010101010;24IM0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0;2013 10 0 1 2:0 0 0,2013 3 23 6 2:0 0 60;81e4;IL',
  'Asia/Kabul': '+0430 +0430 0;4u/0/%z;;;;46e5;AF',
  'Asia/Karachi': '+0500 +0500 0;50/0/PKT;;;;24e6;PK',
  'Asia/Kathmandu': '+0545 +0545 0;5J/0/%z;;;;12e5;NP',
  'Asia/Kolkata': '+0530 +0530 0;5u/0/IST;;;;15e6;IN',
  'Asia/Makassar': '+0800 +0800 0;80/0/WITA;;;;15e5;ID',
  'Asia/Nicosia': '+0200 +0200 60;20/0/EET 30/10/EEST;1010101010101010101010;19LW0 Uor0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;32e4;CY',
  'Asia/Sakhalin': '+1100 +1100 0;b0/0/%z;;;;58e4;RU',
  'Asia/Seoul': '+0900 +0900 0;90/0/KST;;;;23e6;KR',
  'Asia/Shanghai': '+0800 +0800 0;80/0/CST;;;;23e6;CN',
  'Asia/Singapore': '+0800 +0800 0;80/0/%z;;;;71e5;MY',
  'Asia/Tashkent': '+0500 +0500 0;50/0/%z;;;;23e5;UZ',
  'Asia/Tehran': '+0330 +0330 0;3u/0/%z 4u/10/%z;1010;24H8u 1dz0 1cp0 1dz0;;14e6;IR',
  'Asia/Tokyo': '+0900 +0900 0;90/0/JST;;;;38e6;JP',
  'Asia/Vladivostok': '+1000 +1000 0;a0/0/%z;;;;60e4;RU',
  'Asia/Yangon': '+0630 +0630 0;6u/0/%z;;;;48e5;MM',
  'Atlantic/Azores': '+0000 -0100 60;0/0/WET 0/10/%z -10/0/%z;1212121212121212121212;V7d0 195c0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;25e4;PT',
  'Atlantic/Canary': '+0000 +0000 60;0/0/WET 10/10/WEST;1010101010101010101010;oXc0 1Fdd0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;54e4;ES',
  'Atlantic/Cape_Verde': '-0100 -0100 0;-10/0/%z;;;;50e4;CV',
  'Atlantic/Madeira': '+0000 +0000 60;0/0/WET 10/10/WEST;1010101010101010101010;tOo0 1Am10 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;27e4;PT',
  'Australia/Adelaide': '+0930 +0930 60;9u/0/ACST au/10/ACDT;10101010101010101010;2614u 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0;2008 4 1 1 2:0 1 0,2008 10 1 1 2:0 1 60;11e5;AU',
  'Australia/Brisbane': '+1000 +1000 0;a0/0/AEST;;;;20e5;AU',
  'Australia/Broken_Hill': '+0930 +0930 60;9u/0/ACST au/10/ACDT;1010101010101010101010;1d2Cu PJC0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0;2008 4 1 1 2:0 1 0,2008 10 1 1 2:0 1 60;18e3;AU',
  'Australia/Darwin': '+0930 +0930 0;9u/0/ACST;;;;12e4;AU',
  'Australia/Eucla': '+0845 +0845 0;8J/0/%z;;;;368;AU',
  'Australia/Hobart': '+1000 +1000 60;a0/0/AEST b0/10/AEDT;10101010101010101010;26140 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0;2008 4 1 1 2:0 1 0,2001 10 1 1 2:0 1 60;21e4;AU',
  'Australia/Lord_Howe': '+1030 +1030 30;au/0/%z b0/u/%z;10101010101010101010;2613u 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu;2008 4 1 1 2:0 0 0,2008 10 1 1 2:0 0 30;347;AU',
  'Australia/Perth': '+0800 +0800 0;80/0/AWST;;;;18e5;AU',
  'Australia/Sydney': '+1000 +1000 60;a0/0/AEST b0/10/AEDT;10101010101010101010;26140 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0;2008 4 1 1 2:0 1 0,2008 10 1 1 2:0 1 60;40e5;AU',
  'Etc/GMT+12': '-1200 -1200 0;-c0/0/%z',
  'Etc/GMT+7': '-0700 -0700 0;-70/0/%z',
  'Etc/GMT-1': '+0100 +0100 0;10/0/%z',
  'Etc/GMT-2': '+0200 +0200 0;20/0/%z',
  'Etc/UTC': '+0000 +0000 0;0/0/UTC',
  'Europe/Athens': '+0200 +0200 60;20/0/EET 30/10/EEST;1010101010101010101010;24JB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;35e5;GR',
  'Europe/Chisinau': '+0200 +0200 60;20/0/EET 30/10/EEST;1010101010101010101010;24JA0 1qM0 WN0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;67e4;MD',
  'Europe/Dublin': '+0100 +0100 -60;10/0/IST 0/-10/GMT;10101010101010101010;26cp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0;1981 3 0 1 1:0 2 0,1996 10 0 1 1:0 2 -60;12e5;IE',
  'Europe/Istanbul': '+0300 +0300 0;30/0/%z;;;;13e6;TR',
  'Europe/Kyiv': '+0300 +0200 60;30/0/MSK 30/10/EEST 20/0/EET;1212121212121212121212;NSn0 1gi20 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60',
  'Europe/Lisbon': '+0000 +0000 60;0/0/WET 10/10/WEST;1010101010101010101010;24JB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;27e5;PT',
  'Europe/London': '+0000 +0000 60;0/0/GMT 10/10/BST;1010101010101010101010;24JB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;10e6;GBGGIMJE',
  'Europe/Moscow': '+0300 +0300 0;30/0/MSK;;;;16e6;RU',
  'Europe/Paris': '+0100 +0100 60;10/0/CET 20/10/CEST;1010101010101010101010;24JB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;11e6;FR',
  'Europe/Tirane': '+0100 +0100 60;10/0/CET 20/10/CEST;1010101010101010101010;zhX0 1uSq0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00;1996 10 0 1 1:0 2 0,1981 3 0 1 1:0 2 60;42e4;AL',
  'Pacific/Apia': '-1100 +1300 0;-b0/0/%z e0/10/%z d0/0/%z;12;1Gfn0 mwP0;;37e3;WS',
  'Pacific/Auckland': '+1200 +1200 60;c0/0/NZST d0/10/NZDT;10101010101010101010;25We0 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0;2008 4 1 1 2:0 1 0,2007 9 0 1 2:0 1 60;14e5;AQNZ',
  'Pacific/Chatham': '+1245 +1245 60;cJ/0/%z dJ/10/%z;10101010101010101010;25We0 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0;2008 4 1 1 2:45 1 0,2007 9 0 1 2:45 1 60;600;NZ',
  'Pacific/Easter': '-0700 -0600 60;-70/0/%z -50/10/%z -60/0/%z;1212121212121212121212;tG30 1z6o0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0;2019 4 2 1 3:0 2 0,2023 9 2 1 4:0 2 60;30e2;CL',
  'Pacific/Fiji': '+1200 +1200 0;c0/0/%z;;;;88e4;FJ',
  'Pacific/Galapagos': '-0600 -0600 0;-60/0/%z;;;;25e3;EC',
  'Pacific/Gambier': '-0900 -0900 0;-90/0/%z;;;;125;PF',
  'Pacific/Guam': '+1000 +1000 0;a0/0/ChST;;;;17e4;GUMP',
  'Pacific/Honolulu': '-1000 -1000 0;-a0/0/HST;;;;37e4;UMUS',
  'Pacific/Kiritimati': '+1400 +1400 0;e0/0/%z;;;;51e2;KI',
  'Pacific/Marquesas': '-0930 -0930 0;-9u/0/%z;;;;86e2;PF',
  'Pacific/Niue': '-1100 -1100 0;-b0/0/%z;;;;12e2;NU',
  'Pacific/Norfolk': '+1100 +1100 60;b0/0/%z c0/10/%z;10101010101010101010;26130 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0;2008 4 1 1 2:0 1 0,2008 10 1 1 2:0 1 60;25e4;NF',
  'Pacific/Pago_Pago': '-1100 -1100 0;-b0/0/SST;;;;37e2;ASUM',
  'Pacific/Pitcairn': '-0800 -0800 0;-80/0/%z;;;;56;PN',
  'Pacific/Tahiti': '-1000 -1000 0;-a0/0/%z;;;;18e4;PF',
  'Pacific/Tongatapu': '+1300 +1300 0;d0/0/%z;;;;75e3;TO',
  'SystemV/AST4ADT': '-0400 -0400 60;-40/0/AST -30/10/ADT;1010101010101010101010;24US0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0;1976 10 0 1 2:0 0 0,1976 4 0 1 2:0 0 60',
  'SystemV/CST6CDT': '-0600 -0600 60;-60/0/CST -50/10/CDT;1010101010101010101010;24UU0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0;1976 10 0 1 2:0 0 0,1976 4 0 1 2:0 0 60',
  'SystemV/EST5EDT': '-0500 -0500 60;-50/0/EST -40/10/EDT;1010101010101010101010;24UT0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0;1976 10 0 1 2:0 0 0,1976 4 0 1 2:0 0 60',
  'SystemV/MST7MDT': '-0700 -0700 60;-70/0/MST -60/10/MDT;1010101010101010101010;24UV0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0;1976 10 0 1 2:0 0 0,1976 4 0 1 2:0 0 60',
  'SystemV/PST8': '-0800 -0800 0;-80/0/PST',
  'SystemV/PST8PDT': '-0800 -0800 60;-80/0/PST -70/10/PDT;1010101010101010101010;24UW0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0;1976 10 0 1 2:0 0 0,1976 4 0 1 2:0 0 60',
  'SystemV/YST9': '-0900 -0900 0;-90/0/YST',
  'SystemV/YST9YDT': '-0900 -0900 60;-90/0/YST -80/10/YDT;1010101010101010101010;24UX0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0;1976 10 0 1 2:0 0 0,1976 4 0 1 2:0 0 60',
  'Africa/Accra': '!41e5,GH,Africa/Abidjan',
  'Africa/Addis_Ababa': 'Africa/Nairobi',
  'Africa/Asmara': 'Africa/Nairobi',
  'Africa/Asmera': 'Africa/Nairobi',
  'Africa/Bamako': 'Africa/Abidjan',
  'Africa/Bangui': 'Africa/Lagos',
  'Africa/Banjul': 'Africa/Abidjan',
  'Africa/Bissau': '!39e4,GW,Africa/Abidjan',
  'Africa/Blantyre': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Brazzaville': 'Africa/Lagos',
  'Africa/Bujumbura': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Ceuta': '!85e3,ES,Europe/Paris',
  'Africa/Conakry': 'Africa/Abidjan',
  'Africa/Dakar': 'Africa/Abidjan',
  'Africa/Dar_es_Salaam': 'Africa/Nairobi',
  'Africa/Djibouti': 'Africa/Nairobi',
  'Africa/Douala': 'Africa/Lagos',
  'Africa/El_Aaiun': '!20e4,EH,Africa/Casablanca',
  'Africa/Freetown': 'Africa/Abidjan',
  'Africa/Gaborone': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Harare': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Kampala': 'Africa/Nairobi',
  'Africa/Kigali': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Kinshasa': 'Africa/Lagos',
  'Africa/Libreville': 'Africa/Lagos',
  'Africa/Lome': 'Africa/Abidjan',
  'Africa/Luanda': 'Africa/Lagos',
  'Africa/Lubumbashi': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Lusaka': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Malabo': 'Africa/Lagos',
  'Africa/Maputo': '!26e5,BIBWCDMWMZRWZMZW,Africa/Khartoum',
  'Africa/Maseru': 'Africa/Johannesburg',
  'Africa/Mbabane': 'Africa/Johannesburg',
  'Africa/Mogadishu': 'Africa/Nairobi',
  'Africa/Monrovia': '!11e5,LR,Africa/Abidjan',
  'Africa/Ndjamena': '!13e5,TD,Africa/Lagos',
  'Africa/Niamey': 'Africa/Lagos',
  'Africa/Nouakchott': 'Africa/Abidjan',
  'Africa/Ouagadougou': 'Africa/Abidjan',
  'Africa/Porto-Novo': 'Africa/Lagos',
  'Africa/Sao_Tome': '!,ST,Africa/Abidjan',
  'Africa/Timbuktu': 'Africa/Abidjan',
  'Africa/Tunis': '!20e5,TN,Africa/Algiers',
  'Africa/Windhoek': '!32e4,NA,Africa/Khartoum',
  'America/Anguilla': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Antigua': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Araguaina': '!14e4,BR,America/Sao_Paulo',
  'America/Argentina/Buenos_Aires': '!,AR,America/Sao_Paulo',
  'America/Argentina/Catamarca': '!,AR,America/Sao_Paulo',
  'America/Argentina/ComodRivadavia': '!,AR,America/Sao_Paulo',
  'America/Argentina/Cordoba': '!,AR,America/Sao_Paulo',
  'America/Argentina/Jujuy': '!,AR,America/Sao_Paulo',
  'America/Argentina/La_Rioja': '!,AR,America/Sao_Paulo',
  'America/Argentina/Mendoza': '!,AR,America/Sao_Paulo',
  'America/Argentina/Rio_Gallegos': '!,AR,America/Sao_Paulo',
  'America/Argentina/Salta': '!,AR,America/Sao_Paulo',
  'America/Argentina/San_Juan': '!,AR,America/Sao_Paulo',
  'America/Argentina/San_Luis': '!,AR,America/Sao_Paulo',
  'America/Argentina/Tucuman': '!,AR,America/Sao_Paulo',
  'America/Argentina/Ushuaia': '!,AR,America/Sao_Paulo',
  'America/Aruba': '!15e4,AWBQCWSX,America/Santo_Domingo',
  'America/Atikokan': '!28e2,CA,America/Panama',
  'America/Atka': 'America/Adak',
  'America/Bahia': '!27e5,BR,America/Sao_Paulo',
  'America/Bahia_Banderas': '!84e3,MX,America/Mexico_City',
  'America/Barbados': '!28e4,BB,America/Santo_Domingo',
  'America/Belem': '!20e5,BR,America/Sao_Paulo',
  'America/Belize': '!57e3,BZ,America/Managua',
  'America/Blanc-Sablon': '!11e2,CA,America/Santo_Domingo',
  'America/Boa_Vista': '!62e2,BR,America/Caracas',
  'America/Bogota': '!90e5,CO,America/Lima',
  'America/Buenos_Aires': '!,AR,America/Sao_Paulo',
  'America/Cambridge_Bay': '!15e2,CA,America/Denver',
  'America/Campo_Grande': '!77e4,BR,America/Caracas',
  'America/Cancun': '!63e4,MX,America/Panama',
  'America/Catamarca': '!,AR,America/Sao_Paulo',
  'America/Cayenne': '!58e3,GF,America/Sao_Paulo',
  'America/Cayman': 'America/Panama',
  'America/Coral_Harbour': '!28e2,CA,America/Panama',
  'America/Cordoba': '!,AR,America/Sao_Paulo',
  'America/Costa_Rica': '!12e5,CR,America/Managua',
  'America/Creston': '!53e2,CA,America/Phoenix',
  'America/Cuiaba': '!54e4,BR,America/Caracas',
  'America/Curacao': '!15e4,AWBQCWSX,America/Santo_Domingo',
  'America/Danmarkshavn': '!8,GL,Africa/Abidjan',
  'America/Dawson': '!13e2,CA,America/Phoenix',
  'America/Dawson_Creek': '!12e3,CA,America/Phoenix',
  'America/Dominica': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Edmonton': '!10e5,CA,America/Denver',
  'America/Eirunepe': '!31e3,BR,America/Lima',
  'America/El_Salvador': '!11e5,SV,America/Managua',
  'America/Ensenada': '!20e5,MX,America/Los_Angeles',
  'America/Fort_Nelson': '!39e2,CA,America/Phoenix',
  'America/Fort_Wayne': '!America/New_York',
  'America/Fortaleza': '!34e5,BR,America/Sao_Paulo',
  'America/Glace_Bay': '!19e3,CA,America/Halifax',
  'America/Godthab': '!17e3,,America/Nuuk',
  'America/Grand_Turk': '!37e2,TC,America/New_York',
  'America/Grenada': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Guadeloupe': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Guatemala': '!13e5,GT,America/Managua',
  'America/Guayaquil': '!27e5,EC,America/Lima',
  'America/Guyana': '!80e4,GY,America/Caracas',
  'America/Hermosillo': '!64e4,MX,America/Phoenix',
  'America/Indiana/Indianapolis': '!,US,America/New_York',
  'America/Indiana/Knox': '!,US,America/Chicago',
  'America/Indiana/Marengo': '!,US,America/New_York',
  'America/Indiana/Petersburg': '!,US,America/New_York',
  'America/Indiana/Tell_City': '!,US,America/Chicago',
  'America/Indiana/Vevay': '!,US,America/New_York',
  'America/Indiana/Vincennes': '!,US,America/New_York',
  'America/Indiana/Winamac': '!,US,America/New_York',
  'America/Indianapolis': '!America/New_York',
  'America/Inuvik': '!35e2,CA,America/Denver',
  'America/Iqaluit': '!67e2,CA,America/New_York',
  'America/Jamaica': '!94e4,JM,America/Panama',
  'America/Jujuy': '!,AR,America/Sao_Paulo',
  'America/Juneau': '!33e3,US,America/Anchorage',
  'America/Kentucky/Louisville': '!,US,America/New_York',
  'America/Kentucky/Monticello': '!,US,America/New_York',
  'America/Knox_IN': '!,US,America/Chicago',
  'America/Kralendijk': '!15e4,AWBQCWSX,America/Santo_Domingo',
  'America/La_Paz': '!19e5,BO,America/Caracas',
  'America/Louisville': '!,US,America/New_York',
  'America/Lower_Princes': '!15e4,AWBQCWSX,America/Santo_Domingo',
  'America/Maceio': '!93e4,BR,America/Sao_Paulo',
  'America/Manaus': '!19e5,BR,America/Caracas',
  'America/Marigot': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Martinique': '!39e4,MQ,America/Santo_Domingo',
  'America/Matamoros': '!45e4,MX,America/Chicago',
  'America/Mendoza': '!,AR,America/Sao_Paulo',
  'America/Menominee': '!85e2,US,America/Chicago',
  'America/Merida': '!11e5,MX,America/Mexico_City',
  'America/Metlakatla': '!14e2,US,America/Anchorage',
  'America/Moncton': '!64e3,CA,America/Halifax',
  'America/Monterrey': '!41e5,MX,America/Mexico_City',
  'America/Montevideo': '!17e5,UY,America/Sao_Paulo',
  'America/Montreal': '!65e5,CA,America/New_York',
  'America/Montserrat': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Nassau': '!24e4,BS,America/New_York',
  'America/Nipigon': '!16e2,CA,America/New_York',
  'America/Nome': '!38e2,US,America/Anchorage',
  'America/North_Dakota/Beulah': '!,US,America/Chicago',
  'America/North_Dakota/Center': '!,US,America/Chicago',
  'America/North_Dakota/New_Salem': '!,US,America/Chicago',
  'America/Pangnirtung': '!14e2,CA,America/New_York',
  'America/Paramaribo': '!24e4,SR,America/Sao_Paulo',
  'America/Port_of_Spain': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Porto_Acre': '!31e4,BR,America/Lima',
  'America/Porto_Velho': '!37e4,BR,America/Caracas',
  'America/Puerto_Rico': '!24e5,PR,America/Santo_Domingo',
  'America/Punta_Arenas': '!,CL,America/Sao_Paulo',
  'America/Rainy_River': '!842,CA,America/Chicago',
  'America/Rankin_Inlet': '!26e2,CA,America/Chicago',
  'America/Recife': '!33e5,BR,America/Sao_Paulo',
  'America/Regina': '!19e4,CA,America/Managua',
  'America/Resolute': '!229,CA,America/Chicago',
  'America/Rio_Branco': '!31e4,BR,America/Lima',
  'America/Rosario': '!,AR,America/Sao_Paulo',
  'America/Santa_Isabel': '!20e5,MX,America/Los_Angeles',
  'America/Santarem': '!21e4,BR,America/Sao_Paulo',
  'America/Shiprock': 'America/Denver',
  'America/Sitka': '!90e2,US,America/Anchorage',
  'America/St_Barthelemy': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/St_Kitts': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/St_Lucia': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/St_Thomas': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/St_Vincent': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Swift_Current': '!16e3,CA,America/Managua',
  'America/Tegucigalpa': '!11e5,HN,America/Managua',
  'America/Thule': '!656,GL,America/Halifax',
  'America/Thunder_Bay': '!11e4,CA,America/New_York',
  'America/Tijuana': '!20e5,MX,America/Los_Angeles',
  'America/Toronto': '!65e5,CA,America/New_York',
  'America/Tortola': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Virgin': '!43e3,AGAIBLDMGDGPKNLCMFMSTTVCVGVI,America/Santo_Domingo',
  'America/Whitehorse': '!23e3,CA,America/Phoenix',
  'America/Winnipeg': '!66e4,CA,America/Chicago',
  'America/Yakutat': '!642,US,America/Anchorage',
  'America/Yellowknife': '!19e3,CA,America/Denver',
  'Antarctica/Davis': '!70,AQ,Asia/Bangkok',
  'Antarctica/DumontDUrville': '!80,AQ,Asia/Vladivostok',
  'Antarctica/Mawson': '!60,AQ,Asia/Tashkent',
  'Antarctica/McMurdo': 'Pacific/Auckland',
  'Antarctica/Palmer': '!40,AQ,America/Sao_Paulo',
  'Antarctica/Rothera': '!130,AQ,America/Sao_Paulo',
  'Antarctica/South_Pole': 'Pacific/Auckland',
  'Antarctica/Syowa': '!20,AQ,Europe/Istanbul',
  'Arctic/Longyearbyen': '!62e4,NOSJ,Europe/Paris',
  'Asia/Aden': '!57e5,KWSAYE,Europe/Istanbul',
  'Asia/Anadyr': '!13e3,RU,Pacific/Fiji',
  'Asia/Aqtau': '!15e4,KZ,Asia/Tashkent',
  'Asia/Aqtobe': '!27e4,KZ,Asia/Tashkent',
  'Asia/Ashgabat': '!41e4,TM,Asia/Tashkent',
  'Asia/Ashkhabad': '!41e4,TM,Asia/Tashkent',
  'Asia/Atyrau': '!,KZ,Asia/Tashkent',
  'Asia/Baghdad': '!66e5,IQ,Europe/Istanbul',
  'Asia/Bahrain': '!96e4,BHQA,Europe/Istanbul',
  'Asia/Baku': '!27e5,AZ,Asia/Dubai',
  'Asia/Barnaul': '!,RU,Asia/Bangkok',
  'Asia/Bishkek': '!87e4,KG,Asia/Dhaka',
  'Asia/Brunei': '!42e4,BN,Asia/Singapore',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Choibalsan': '!38e3,MN,Asia/Singapore',
  'Asia/Chongqing': 'Asia/Shanghai',
  'Asia/Chungking': 'Asia/Shanghai',
  'Asia/Dacca': 'Asia/Dhaka',
  'Asia/Dili': '!19e4,TL,Asia/Chita',
  'Asia/Dushanbe': '!76e4,TJ,Asia/Tashkent',
  'Asia/Harbin': 'Asia/Shanghai',
  'Asia/Hebron': '!25e4,PS,Asia/Gaza',
  'Asia/Ho_Chi_Minh': '!90e5,VN,Asia/Bangkok',
  'Asia/Hovd': '!81e3,MN,Asia/Bangkok',
  'Asia/Irkutsk': '!60e4,RU,Asia/Singapore',
  'Asia/Istanbul': 'Europe/Istanbul',
  'Asia/Kamchatka': '!18e4,RU,Pacific/Fiji',
  'Asia/Kashgar': '!32e5,CN,Asia/Dhaka',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Khandyga': '!66e2,RU,Asia/Chita',
  'Asia/Krasnoyarsk': '!10e5,RU,Asia/Bangkok',
  'Asia/Kuala_Lumpur': 'Asia/Singapore',
  'Asia/Kuching': '!13e4,MY,Asia/Singapore',
  'Asia/Kuwait': '!57e5,KWSAYE,Europe/Istanbul',
  'Asia/Macao': '!57e4,MO,Asia/Shanghai',
  'Asia/Macau': '!57e4,MO,Asia/Shanghai',
  'Asia/Magadan': '!95e3,RU,Asia/Sakhalin',
  'Asia/Manila': '!24e6,PH,Asia/Tokyo',
  'Asia/Muscat': 'Asia/Dubai',
  'Asia/Novokuznetsk': '!55e4,RU,Asia/Bangkok',
  'Asia/Novosibirsk': '!15e5,RU,Asia/Bangkok',
  'Asia/Omsk': '!12e5,RU,Asia/Dhaka',
  'Asia/Oral': '!27e4,KZ,Asia/Tashkent',
  'Asia/Phnom_Penh': 'Asia/Bangkok',
  'Asia/Pontianak': '!23e4,ID,Asia/Jakarta',
  'Asia/Pyongyang': '!29e5,KP,Asia/Seoul',
  'Asia/Qatar': '!96e4,BHQA,Europe/Istanbul',
  'Asia/Qostanay': '!,KZ,Asia/Almaty',
  'Asia/Qyzylorda': '!73e4,KZ,Asia/Tashkent',
  'Asia/Rangoon': '!48e5,,Asia/Yangon',
  'Asia/Riyadh': '!57e5,KWSAYE,Europe/Istanbul',
  'Asia/Saigon': '!90e5,VN,Asia/Bangkok',
  'Asia/Samarkand': '!36e4,UZ,Asia/Tashkent',
  'Asia/Srednekolymsk': '!35e2,RU,Asia/Sakhalin',
  'Asia/Taipei': '!74e5,TW,Asia/Shanghai',
  'Asia/Tbilisi': '!11e5,GE,Asia/Dubai',
  'Asia/Tel_Aviv': 'Asia/Jerusalem',
  'Asia/Thimbu': '!79e3,BT,Asia/Dhaka',
  'Asia/Thimphu': '!79e3,BT,Asia/Dhaka',
  'Asia/Tomsk': '!10e5,RU,Asia/Bangkok',
  'Asia/Ujung_Pandang': 'Asia/Makassar',
  'Asia/Ulaanbaatar': '!12e5,MN,Asia/Singapore',
  'Asia/Ulan_Bator': '!12e5,MN,Asia/Singapore',
  'Asia/Urumqi': '!32e5,CN,Asia/Dhaka',
  'Asia/Ust-Nera': '!65e2,RU,Asia/Vladivostok',
  'Asia/Vientiane': 'Asia/Bangkok',
  'Asia/Yakutsk': '!28e4,RU,Asia/Chita',
  'Asia/Yekaterinburg': '!14e5,RU,Asia/Tashkent',
  'Asia/Yerevan': '!13e5,AM,Asia/Dubai',
  'Atlantic/Bermuda': '!65e3,BM,America/Halifax',
  'Atlantic/Faeroe': '!49e3,FO,Europe/Lisbon',
  'Atlantic/Faroe': '!49e3,FO,Europe/Lisbon',
  'Atlantic/Jan_Mayen': '!62e4,NOSJ,Europe/Paris',
  'Atlantic/Reykjavik': '!12e4,IS,Africa/Abidjan',
  'Atlantic/South_Georgia': '!30,GS,America/Noronha',
  'Atlantic/St_Helena': 'Africa/Abidjan',
  'Atlantic/Stanley': '!21e2,FK,America/Sao_Paulo',
  'Australia/ACT': 'Australia/Sydney',
  'Australia/Canberra': 'Australia/Sydney',
  'Australia/Currie': '!746,AU,Australia/Hobart',
  'Australia/LHI': 'Australia/Lord_Howe',
  'Australia/Lindeman': '!10,AU,Australia/Brisbane',
  'Australia/Melbourne': '!39e5,AU,Australia/Sydney',
  'Australia/NSW': 'Australia/Sydney',
  'Australia/North': 'Australia/Darwin',
  'Australia/Queensland': 'Australia/Brisbane',
  'Australia/South': 'Australia/Adelaide',
  'Australia/Tasmania': 'Australia/Hobart',
  'Australia/Victoria': '!39e5,AU,Australia/Sydney',
  'Australia/West': 'Australia/Perth',
  'Australia/Yancowinna': 'Australia/Broken_Hill',
  'Brazil/Acre': '!31e4,BR,America/Lima',
  'Brazil/DeNoronha': 'America/Noronha',
  'Brazil/East': 'America/Sao_Paulo',
  'Brazil/West': '!19e5,BR,America/Caracas',
  'CET': '!Europe/Paris',
  'CST6CDT': '!America/Chicago',
  'Canada/Atlantic': 'America/Halifax',
  'Canada/Central': '!66e4,CA,America/Chicago',
  'Canada/Eastern': '!65e5,CA,America/New_York',
  'Canada/Mountain': '!10e5,CA,America/Denver',
  'Canada/Newfoundland': 'America/St_Johns',
  'Canada/Pacific': 'America/Vancouver',
  'Canada/Saskatchewan': '!19e4,CA,America/Managua',
  'Canada/Yukon': '!23e3,CA,America/Phoenix',
  'Chile/Continental': 'America/Santiago',
  'Chile/EasterIsland': 'Pacific/Easter',
  'Cuba': 'America/Havana',
  'EET': '!Europe/Athens',
  'EST': '!America/Panama',
  'EST5EDT': '!America/New_York',
  'Egypt': 'Africa/Cairo',
  'Eire': 'Europe/Dublin',
  'Etc/GMT': '!Africa/Abidjan',
  'Etc/GMT+0': '!Africa/Abidjan',
  'Etc/GMT+1': '!Atlantic/Cape_Verde',
  'Etc/GMT+10': '!Pacific/Tahiti',
  'Etc/GMT+11': '!Pacific/Niue',
  'Etc/GMT+2': '!30,GS,America/Noronha',
  'Etc/GMT+3': '!America/Sao_Paulo',
  'Etc/GMT+4': '!America/Caracas',
  'Etc/GMT+5': '!America/Lima',
  'Etc/GMT+6': '!Pacific/Galapagos',
  'Etc/GMT+8': '!Pacific/Pitcairn',
  'Etc/GMT+9': '!Pacific/Gambier',
  'Etc/GMT-0': '!Africa/Abidjan',
  'Etc/GMT-10': '!25e4,PG,Asia/Vladivostok',
  'Etc/GMT-11': '!Asia/Sakhalin',
  'Etc/GMT-12': '!29e3,KI,Pacific/Fiji',
  'Etc/GMT-13': '!Pacific/Tongatapu',
  'Etc/GMT-14': '!Pacific/Kiritimati',
  'Etc/GMT-3': '!Europe/Istanbul',
  'Etc/GMT-4': '!Asia/Dubai',
  'Etc/GMT-5': '!Asia/Tashkent',
  'Etc/GMT-6': '!Asia/Dhaka',
  'Etc/GMT-7': '!21e2,CX,Asia/Bangkok',
  'Etc/GMT-8': '!Asia/Singapore',
  'Etc/GMT-9': '!21e3,PW,Asia/Chita',
  'Etc/GMT0': '!Africa/Abidjan',
  'Etc/Greenwich': '!Africa/Abidjan',
  'Etc/UCT': 'Etc/UTC',
  'Etc/Universal': 'Etc/UTC',
  'Etc/Zulu': 'Etc/UTC',
  'Europe/Amsterdam': '!16e5,NL,Europe/Paris',
  'Europe/Andorra': '!79e3,AD,Europe/Paris',
  'Europe/Astrakhan': '!10e5,RU,Asia/Dubai',
  'Europe/Belfast': 'Europe/London',
  'Europe/Belgrade': '!12e5,BAHRMEMKRSSI,Europe/Paris',
  'Europe/Berlin': '!41e5,DE,Europe/Paris',
  'Europe/Bratislava': '!13e5,CZSK,Europe/Paris',
  'Europe/Brussels': '!21e5,BE,Europe/Paris',
  'Europe/Bucharest': '!19e5,RO,Europe/Athens',
  'Europe/Budapest': '!17e5,HU,Europe/Paris',
  'Europe/Busingen': '!38e4,CHDELI,Europe/Paris',
  'Europe/Copenhagen': '!12e5,DK,Europe/Paris',
  'Europe/Gibraltar': '!30e3,GI,Europe/Paris',
  'Europe/Guernsey': 'Europe/London',
  'Europe/Helsinki': '!12e5,AXFI,Europe/Athens',
  'Europe/Isle_of_Man': 'Europe/London',
  'Europe/Jersey': 'Europe/London',
  'Europe/Kaliningrad': '!44e4,RU,Africa/Tripoli',
  'Europe/Kiev': '!34e5,UA,Europe/Kyiv',
  'Europe/Kirov': '!48e4,RU,Europe/Moscow',
  'Europe/Ljubljana': '!12e5,BAHRMEMKRSSI,Europe/Paris',
  'Europe/Luxembourg': '!54e4,LU,Europe/Paris',
  'Europe/Madrid': '!62e5,ES,Europe/Paris',
  'Europe/Malta': '!42e4,MT,Europe/Paris',
  'Europe/Mariehamn': '!12e5,AXFI,Europe/Athens',
  'Europe/Minsk': '!19e5,BY,Europe/Istanbul',
  'Europe/Monaco': '!38e3,MC,Europe/Paris',
  'Europe/Nicosia': 'Asia/Nicosia',
  'Europe/Oslo': '!62e4,NOSJ,Europe/Paris',
  'Europe/Podgorica': '!12e5,BAHRMEMKRSSI,Europe/Paris',
  'Europe/Prague': '!13e5,CZSK,Europe/Paris',
  'Europe/Riga': '!64e4,LV,Europe/Athens',
  'Europe/Rome': '!39e5,ITSMVA,Europe/Paris',
  'Europe/Samara': '!12e5,RU,Asia/Dubai',
  'Europe/San_Marino': '!39e5,ITSMVA,Europe/Paris',
  'Europe/Sarajevo': '!12e5,BAHRMEMKRSSI,Europe/Paris',
  'Europe/Saratov': '!,RU,Asia/Dubai',
  'Europe/Simferopol': '!33e4,RUUA,Europe/Moscow',
  'Europe/Skopje': '!12e5,BAHRMEMKRSSI,Europe/Paris',
  'Europe/Sofia': '!12e5,BG,Europe/Athens',
  'Europe/Stockholm': '!15e5,SE,Europe/Paris',
  'Europe/Tallinn': '!41e4,EE,Europe/Athens',
  'Europe/Tiraspol': 'Europe/Chisinau',
  'Europe/Ulyanovsk': '!13e5,RU,Asia/Dubai',
  'Europe/Uzhgorod': '!11e4,UA,Europe/Kyiv',
  'Europe/Vaduz': '!38e4,CHDELI,Europe/Paris',
  'Europe/Vatican': '!39e5,ITSMVA,Europe/Paris',
  'Europe/Vienna': '!18e5,AT,Europe/Paris',
  'Europe/Vilnius': '!54e4,LT,Europe/Athens',
  'Europe/Volgograd': '!10e5,RU,Europe/Moscow',
  'Europe/Warsaw': '!17e5,PL,Europe/Paris',
  'Europe/Zagreb': '!12e5,BAHRMEMKRSSI,Europe/Paris',
  'Europe/Zaporozhye': '!77e4,UA,Europe/Kyiv',
  'Europe/Zurich': '!38e4,CHDELI,Europe/Paris',
  'GB': 'Europe/London',
  'GB-Eire': 'Europe/London',
  'GMT': '!Africa/Abidjan',
  'GMT+0': '!Africa/Abidjan',
  'GMT-0': '!Africa/Abidjan',
  'GMT0': '!Africa/Abidjan',
  'Greenwich': '!Africa/Abidjan',
  'HST': '!Pacific/Honolulu',
  'Hongkong': 'Asia/Hong_Kong',
  'Iceland': '!12e4,IS,Africa/Abidjan',
  'Indian/Antananarivo': 'Africa/Nairobi',
  'Indian/Chagos': '!30e2,IO,Asia/Dhaka',
  'Indian/Christmas': '!21e2,CX,Asia/Bangkok',
  'Indian/Cocos': '!596,CC,Asia/Yangon',
  'Indian/Comoro': 'Africa/Nairobi',
  'Indian/Kerguelen': '!130,TF,Asia/Tashkent',
  'Indian/Mahe': '!79e3,SC,Asia/Dubai',
  'Indian/Maldives': '!35e4,MV,Asia/Tashkent',
  'Indian/Mauritius': '!15e4,MU,Asia/Dubai',
  'Indian/Mayotte': 'Africa/Nairobi',
  'Indian/Reunion': '!84e4,RETF,Asia/Dubai',
  'Iran': 'Asia/Tehran',
  'Israel': 'Asia/Jerusalem',
  'Jamaica': '!94e4,JM,America/Panama',
  'Japan': 'Asia/Tokyo',
  'Kwajalein': '!14e3,MH,Pacific/Fiji',
  'Libya': 'Africa/Tripoli',
  'MET': '!Europe/Paris',
  'MST': '!America/Phoenix',
  'MST7MDT': '!America/Denver',
  'Mexico/BajaNorte': '!20e5,MX,America/Los_Angeles',
  'Mexico/BajaSur': 'America/Mazatlan',
  'Mexico/General': 'America/Mexico_City',
  'NZ': 'Pacific/Auckland',
  'NZ-CHAT': 'Pacific/Chatham',
  'Navajo': 'America/Denver',
  'PRC': 'Asia/Shanghai',
  'PST8PDT': '!America/Los_Angeles',
  'Pacific/Bougainville': '!18e4,PG,Asia/Sakhalin',
  'Pacific/Chuuk': '!49e3,FM,Asia/Vladivostok',
  'Pacific/Efate': '!66e3,VU,Asia/Sakhalin',
  'Pacific/Enderbury': '!1,KI,Pacific/Tongatapu',
  'Pacific/Fakaofo': '!483,TK,Pacific/Tongatapu',
  'Pacific/Funafuti': '!29e3,KI,Pacific/Fiji',
  'Pacific/Guadalcanal': '!11e4,SB,Asia/Sakhalin',
  'Pacific/Johnston': 'Pacific/Honolulu',
  'Pacific/Kanton': '!1,KI,Pacific/Tongatapu',
  'Pacific/Kosrae': '!66e2,FM,Asia/Sakhalin',
  'Pacific/Kwajalein': '!14e3,MH,Pacific/Fiji',
  'Pacific/Majuro': '!28e3,MH,Pacific/Fiji',
  'Pacific/Midway': 'Pacific/Pago_Pago',
  'Pacific/Nauru': '!10e3,NR,Pacific/Fiji',
  'Pacific/Noumea': '!98e3,NC,Asia/Sakhalin',
  'Pacific/Palau': '!21e3,PW,Asia/Chita',
  'Pacific/Pohnpei': '!34e3,FM,Asia/Sakhalin',
  'Pacific/Ponape': '!34e3,FM,Asia/Sakhalin',
  'Pacific/Port_Moresby': '!25e4,PG,Asia/Vladivostok',
  'Pacific/Rarotonga': '!13e3,CK,Pacific/Tahiti',
  'Pacific/Saipan': 'Pacific/Guam',
  'Pacific/Samoa': 'Pacific/Pago_Pago',
  'Pacific/Tarawa': '!29e3,KI,Pacific/Fiji',
  'Pacific/Truk': '!49e3,FM,Asia/Vladivostok',
  'Pacific/Wake': '!29e3,KI,Pacific/Fiji',
  'Pacific/Wallis': '!29e3,KI,Pacific/Fiji',
  'Pacific/Yap': '!49e3,FM,Asia/Vladivostok',
  'Poland': '!17e5,PL,Europe/Paris',
  'Portugal': 'Europe/Lisbon',
  'ROC': '!74e5,TW,Asia/Shanghai',
  'ROK': 'Asia/Seoul',
  'Singapore': 'Asia/Singapore',
  'SystemV/AST4': '!America/Santo_Domingo',
  'SystemV/CST6': '!America/Managua',
  'SystemV/EST5': '!America/Panama',
  'SystemV/HST10': '!Pacific/Honolulu',
  'SystemV/MST7': '!America/Phoenix',
  'Turkey': 'Europe/Istanbul',
  'UCT': 'Etc/UTC',
  'US/Alaska': 'America/Anchorage',
  'US/Aleutian': 'America/Adak',
  'US/Arizona': 'America/Phoenix',
  'US/Central': 'America/Chicago',
  'US/East-Indiana': '!America/New_York',
  'US/Eastern': 'America/New_York',
  'US/Hawaii': 'Pacific/Honolulu',
  'US/Indiana-Starke': '!,US,America/Chicago',
  'US/Michigan': 'America/Detroit',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Pacific-New': '!America/Los_Angeles',
  'US/Samoa': 'Pacific/Pago_Pago',
  'UTC': 'Etc/UTC',
  'Universal': 'Etc/UTC',
  'W-SU': 'Europe/Moscow',
  'WET': '!Europe/Lisbon',
  'Zulu': 'Etc/UTC'
}/* trim-file-end */;

Object.freeze(timezoneSmall);
export default timezoneSmall;
